import hasRole from './permission/hasRole'
import hasPermi from './permission/hasPermi'

const install = function(app) {
  app.directive('hasRole', hasRole)
  app.directive('hasPermi', hasPermi)
}

if (window.Vue) {
  window['hasRole'] = hasRole
  window['hasPermi'] = hasPermi
  app.use(install); // eslint-disable-line
}

export default install
